import { Component, OnInit } from '@angular/core';
import { NavController, Platform } from '@ionic/angular';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';




declare var faceapi: any;

@Component({
  selector: 'app-digitalcertificate',
  templateUrl: './digitalcertificate.component.html',
  styleUrls: ['./digitalcertificate.component.scss'],
})
export class DigitalcertificateComponent implements OnInit {

  headerTitle: any = "";
  imagename: any = "";
  langcontext: any = "";
  FileSelected: any;
  constructor(public platform: Platform, public navCtrl: NavController, public cmndecl: CommonDeclarationService, public cmndef: CommonDefinitionService, public camera: Camera, public statusBar: StatusBar) {
    this.imagename = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRP2LAcD7cotvQybIVkSQ4AXrBlAHKrdiukGA&usqp=CAU"
    this.getImageDetails();
  }

  ngOnInit() {
    if (this.cmndecl.LanguageJson) {
      this.langcontext = this.cmndecl.LanguageJson.pages[0]['youtubeVideo'];
      // this.headerTitle = this.langcontext.hdr;
      this.headerTitle = "Digital Certificate";
    }
    else {
      this.cmndecl.LanguageJson = JSON.parse(localStorage.languageJson);
      this.langcontext = this.cmndecl.LanguageJson['pages'][0].youtubeVideo;
      // this.headerTitle = this.langcontext.hdr;
      this.headerTitle = "Easy Access";
    }
  }

  async getImageDetails() {
    await faceapi.loadSsdMobilenetv1Model('https://raw.githubusercontent.com/justadudewhohacks/face-api.js/master/weights');
    await faceapi.nets.faceLandmark68Net.loadFromUri('https://raw.githubusercontent.com/justadudewhohacks/face-api.js/master/weights');
    await faceapi.nets.tinyFaceDetector.loadFromUri('https://raw.githubusercontent.com/justadudewhohacks/face-api.js/master/weights');
    await faceapi.nets.faceRecognitionNet.loadFromUri('https://raw.githubusercontent.com/justadudewhohacks/face-api.js/master/weights');
    await faceapi.nets.faceExpressionNet.loadFromUri('https://raw.githubusercontent.com/justadudewhohacks/face-api.js/master/weights');
  }

  getLanguageDetails() {
    console.log("hello");
  }

  async recentUpload() {
    console.log(this.cmndecl.BrowserBuild)
    if (this.cmndecl.BrowserBuild != 1) {
      this.pickImage(this.camera.PictureSourceType.CAMERA)
    }
  }

  pickImage(sourceType) {
    let cameradir: any;
    const options: CameraOptions = {
      quality: localStorage.imagequality,
      sourceType: sourceType,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      cameraDirection: cameradir,
      correctOrientation: true
    }
    this.camera.getPicture(options).then(async (imageData) => {
      if (this.platform.is('ios')) {
        await this.statusBar.overlaysWebView(true);
        await this.statusBar.overlaysWebView(false);
      }
      let base64Image = 'data:image/jpeg;base64,' + imageData;
      let stringLength: number = Number(imageData.length);
      let sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
      let sizeInMB = sizeInBytes / 1000000;
      if (Math.floor(sizeInMB) <= Number(localStorage.imgsize)) {
        this.imagename = base64Image;
        setTimeout(() => {
          this.checkImg();
        }, 3000);
      } else
        this.cmndef.presentAlert("", this.cmndecl.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid")
    }, async (err) => {
      if (this.platform.is('ios')) {
        await this.statusBar.overlaysWebView(true);
        await this.statusBar.overlaysWebView(false);
      } else {
        console.log("Error");
      }
    });
  }

  async checkImg() {
    // console.log("checking the logs");
    let img = document.getElementById('refimg');
    let fullFaceDescriptions = await faceapi.detectAllFaces(img, new faceapi.TinyFaceDetectorOptions()).withFaceLandmarks().withFaceExpressions()
    if (fullFaceDescriptions.length == 1)
      alert("Your face is detected.")
    else if (fullFaceDescriptions.length > 1)
      alert("Multipe face detected. Please capture again")
    else
      alert("Your face is not detected. Please capture again")

    fullFaceDescriptions = faceapi.resizeResults(fullFaceDescriptions, img)
    console.log(fullFaceDescriptions)
  }

  changeListener($event, flg): void {
    let name: any;
    let validFormate: any;
    let imgname: any;
    let sizeInBytes: any;
    let stringLength: any;
    let sizeInMB: any;
    name = $event.target.files[0].name;
    this.FileSelected = flg;
    validFormate = name.substring(name.lastIndexOf("."), name.length);
    if (validFormate.toLowerCase() == ".jpg" || validFormate.toLowerCase() == ".jpeg" || validFormate.toLowerCase() == ".pdf" || validFormate.toLowerCase() == ".tiff" || validFormate.toLowerCase() == ".png") {
      this.cmndef.readThis($event.target).then(data => {
        imgname = data;
        stringLength = imgname.length - imgname.indexOf("64,") + 3;
        sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
        sizeInMB = sizeInBytes / 1000000;
        console.log(sizeInMB);
        if (Math.round(sizeInMB) <= Number(localStorage.imgsize)) {
          this.imagename = imgname;
          setTimeout(() => {
            this.checkImg();
          }, 3000)
        } else {
          this.cmndef.presentAlert("", this.cmndecl.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid")
        }
      })
    } else {
      this.cmndef.presentAlert("", this.cmndecl.LanguageJson.pages[0]['alerts'].invalidImage, "invalid")
    }
  }

  startVideo(){
    console.log("hello how are you");
  }

}
